import React from 'react'
import lowerCase from 'lodash/lowerCase'
import { Link } from 'react-router'
import { DataCard, OptionsMenu, Details, Title, Message, Badge, DarkBlueBadge } from '../data-card/data-card-parts'

const QAWorkOrderCard = ({
  qaWorkOrder = {},
  location = {},
  accountManagers = [],

  onSubmitForApproval,
  onDelete
}) => (
  <DataCard>
    <OptionsMenu optionItems={[
      {
        name: 'Submit for Approval',
        action: onSubmitForApproval
      },
      {
        name: 'Delete',
        action: onDelete
      }
    ]} />

    <Link to={`quality-assurance/${qaWorkOrder.id}`}>
      <Details>
        <Title text={location.name} />
        {statusBadge(qaWorkOrder.status)}
      </Details>

      <Message text={`Managers: ${
        accountManagers && accountManagers.length
          ? accountManagers.map(am => am.name).join(', ')
          : 'None'
      }`} />
    </Link>
  </DataCard>
)

export default QAWorkOrderCard

function statusBadge (status) {
  const formattedStatus = lowerCase(status)

  const cases = {
    open: <DarkBlueBadge text={formattedStatus} />,
    in_progress: <Badge text={formattedStatus} color={'#c5aa21'} />,
    pending_approval: <Badge text={'✓ ' + formattedStatus} color={'#71c326'} />,
    default: <Badge text={formattedStatus} color={'gray'} />
  }

  return cases[status] || cases.default
}



// WEBPACK FOOTER //
// ./src/components/qa-work-orders/qa-work-order-card.js